import React from "react";
import Popup from "../ui/Popup";
import SlotGrid from "../reservations/SlotGrid";
import { getActivityByTable } from "../../config/activities";
import { memberLabel } from "../../lib/slots";

/** Lets the visitor move an active reservation to another slot of the same activity. */
const TimeChangeModal = ({ reservation, availability = {}, capacityInfo = {}, onClose, onSelect }) => {
  if (!reservation) return null;

  const activity = getActivityByTable(reservation.table);
  const teamSize = Number(reservation.participantCount) || 1;

  return (
    <Popup isOpen onClose={onClose} title="Změnit čas rezervace" wide>
      <p>
        Vyberte nový čas pro tým <b className="text-marigold">{reservation.teamName}</b> ({activity.shortName}).
      </p>
      <p className="text-sm">
        Tým má {teamSize} {memberLabel(teamSize)}. Aktivní jsou pouze sloty s dostatečnou kapacitou; aktuální čas je
        zvýrazněn.
      </p>
      <SlotGrid
        slots={activity.slots}
        availability={availability}
        capacityInfo={capacityInfo}
        onChange={(slot) => onSelect(reservation, slot)}
        teamSize={teamSize}
        currentSlot={reservation.time_slot}
        wide
      />
      <div className="modal-actions">
        <button type="button" className="btn btn-ghost" onClick={onClose}>
          Zrušit
        </button>
      </div>
    </Popup>
  );
};

export default TimeChangeModal;
